itsoftApp.createModule("headerFix", ["pageLoad", "windowScroll", "windowResize"], function () {
    const module = this;

    const Header = function () {
        this.header = document.querySelector(".page-header");
        this.pageWrapper = document.querySelector(".l-wrapper");
        this.headerFixed = false;
        this.paddingElems = document.querySelectorAll(".js-padding");
        this.headerHeight;

        this.init();
    };

    Header.prototype.setPagePadding = function () {
        const HEADER = this;
        // учитывается, что высота шапки может поменяться по мере скролла, поэтому нужно измерить высоту шапки в нормальном состоянии

        if (HEADER.paddingElems) {
            Array.prototype.forEach.call(HEADER.paddingElems, function (el) {
                el.style.paddingTop = itsoftApp.calculations.headerStaticHeight + "px";
            });
        } else {
            HEADER.pageWrapper.style.paddingTop = itsoftApp.calculations.headerStaticHeight + "px";
        }
    };

    Header.prototype.updHeaderHeightAndPadding = function () {
        const HEADER = this;
        
        if (HEADER.header) {
            HEADER.header.classList.remove("js-fixed");

            if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight) {
                itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.headerHeight = true;
                itsoftApp.calculations.headerHeight = itsoftApp.utils.getHeaderHeight();
            }

            HEADER.headerHeight = itsoftApp.calculations.headerHeight;
            if (pageYOffset !== 0) {
                HEADER.header.classList.add("js-fixed");
            }
            HEADER.setPagePadding();
        }
    };

    Header.prototype.modifyHeader = function () {
        const HEADER = this;
        if (pageYOffset > 0 && !HEADER.headerFixed) {
            HEADER.header.classList.add("js-fixed");
            HEADER.headerFixed = true;
        } else if (pageYOffset === 0) {
            HEADER.header.classList.remove("js-fixed");
            HEADER.headerFixed = false;
        }
    };

    Header.prototype.init = function () {
        const HEADER = this;

        if (HEADER.header) {
            itsoftApp.modules.pageLoad.addEvent(function () {
                HEADER.headerHeight = itsoftApp.utils.getHeaderHeight();

                if (pageYOffset > 0 && !HEADER.headerFixed) {
                    itsoftApp.utils.getHeaderStaticHeight();
                    HEADER.header.classList.add("js-fixed");
                    HEADER.headerFixed = true;
                    itsoftApp.utils.getHeaderFixedHeight();
                } else if (pageYOffset === 0) {
                    itsoftApp.utils.getHeaderStaticHeight();
                    itsoftApp.utils.getHeaderFixedHeight(); // TODO: надо оптимизировать лишнее вычисление
                    // HEADER.header.classList.remove("js-fixed");
                    HEADER.headerFixed = false;
                }

                itsoftApp.modules.windowResize.addEvent(HEADER.updHeaderHeightAndPadding.bind(HEADER));
                itsoftApp.modules.windowScroll.addEvent(HEADER.modifyHeader.bind(HEADER));
                HEADER.modifyHeader();
                HEADER.setPagePadding();

                if (HEADER.header.hasAttribute("data-default")) {
                    HEADER.header.removeAttribute("data-default");
                }
            });
        }
    };

    new Header();
    module.callback = Header;
});
